import React, {useState} from 'react';
import {Button, Col, Menu} from "antd";
import {DownloadOutlined, RedoOutlined} from "@ant-design/icons";
import {CONSTANTS} from "../../utils/constant";

export default function ResultMenu({resultTitle, resultPath}) {

    const [menuItemIndex, setMenuItemIndex] = useState('1');

    const scrollToSection = (id, idx) => {
        document.getElementById(id).scrollIntoView({behavior: 'smooth'});
        setMenuItemIndex(idx);
    };

    const downloadResult = async () => {
        const fileUrl = CONSTANTS.BASE_PATH + resultPath.replace('../', '') + 'data.rar'; // URL del file

        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = resultTitle.replaceAll(' ', '_') + '.rar';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Errore nel download del file:", error);
        }
    };

    return (
        <>
            <Col style={{lineHeight: '45px', paddingLeft: '20px', paddingRight: '20px', margin: '0'}}>
                <h2 style={{margin: 0}}>{resultTitle}</h2>
            </Col>
            <Col flex={"auto"}>
                <Menu theme="light" defaultSelectedKeys={['1']} selectedKeys={[menuItemIndex]} mode="horizontal">
                    <Menu.Item key={0}>
                        <a href={"/BioTools/cocomaps2"} to="/">HOME</a>
                    </Menu.Item>
                    <Menu.Item key={1}>
                        <a onClick={() => scrollToSection('molstar', 1)}>INTERACTIONS</a>
                    </Menu.Item>
                    <Menu.Item key={2}>
                        <a onClick={() => scrollToSection('charts', 2)}>CHARTS</a>
                    </Menu.Item>
                    <Menu.Item key={3}>
                        <a onClick={() => scrollToSection('ASA', 3)}>ASA</a>
                    </Menu.Item>
                </Menu>
            </Col>
            <Col flex={"auto"} style={{textAlign: "right"}}>
                <div style={{top: '9px', position: 'relative'}}>
                    <Button icon={<DownloadOutlined/>} style={{marginRight: '10px'}} onClick={downloadResult}>Download results</Button>
                    <Button icon={<RedoOutlined/>} style={{marginRight: '10px'}} onClick={() => window.location.reload()}>Reset</Button>
                </div>
            </Col>
        </>
    )
}